module.exports = __webpack_public_path__ + "img/search-icon.52776896.svg";